(function() {
    angular.module('vholsDirectivesGeneral', [])       

        .directive("scrollEvents", ["$window", "$rootScope", function ($window, $rootScope) {

            return {
                restrict: 'A',
                link: function($scope, $element, $attr) {

                    var emitter, tolerance = parseInt($attr.tolerance || "0", 10);

                    emitter = createEmitter($attr.scrollEvents);
                    $window.addEventListener("resize", emitter);
                    $window.addEventListener("scroll", emitter);

                    $scope.$on("$destroy", function() {
                        $window.removeEventListener("resize", emitter);
                        $window.removeEventListener("scroll", emitter);
                    });

                    function createEmitter(eventName) {
                        return function() {
                            var topVisible, bottomVisible, visible,
                                rect = $element[0].getBoundingClientRect();

                            topVisible = rect.top > tolerance;
                            bottomVisible = rect.bottom < $window.innerHeight + tolerance;
                            visible = topVisible || bottomVisible || (rect.top < 0 && rect.bottom > $window.innerHeight);

                            $scope.$emit(eventName, {
                                topVisible: topVisible,
                                bottomVisible: bottomVisible,
                                visible: visible,
                                bounds: rect
                            });
                        };
                    }
                }
            };
        }]);
})();
'use strict';

angular.module('vholsDirectivesGeneral').run(['$templateCache', function($templateCache) {

}]);